import { render } from "./SubjectAssignmentForm.vue?vue&type=template&id=2fed4bb8&scoped=true"
import script from "./SubjectAssignmentForm.vue?vue&type=script&lang=js"
export * from "./SubjectAssignmentForm.vue?vue&type=script&lang=js"

import "./SubjectAssignmentForm.vue?vue&type=style&index=0&id=2fed4bb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fed4bb8"]])

export default __exports__